const PropertyAPI = {
  baseUrl: "https://api.goprovalo.com/property_catalog_api.php",

  filtersUrl: "https://api.goprovalo.com/property-filters.php",

  async requestJson(url) {
    const response = await fetch(url, {
      method: "GET",
      mode: "cors",
      headers: {
        Accept: "application/json",
      },
    });

    const responseText = await response.text();
    let result;

    try {
      result = JSON.parse(responseText);
    } catch (error) {
      console.error("Invalid property API response:", responseText);

      throw new Error(
        "The property service returned an invalid response."
      );
    }

    if (!response.ok || !result.success) {
      throw new Error(
        result.message ||
        result.error ||
        "The property request failed."
      );
    }

    return result;
  },

  async getProperties(params = {}) {
    const query = new URLSearchParams(params).toString();

    return this.requestJson(
      `${this.baseUrl}?${query}`
    );
  },

  async getFilters() {
    return this.requestJson(this.filtersUrl);
  },
};